const Utils = require('core-helpers/utils.js');
const GTM = require('tracking/tracking-gtm.js');
const Optimizely = require('tracking/tracking-optimizely.js');
const Snowplow = require('tracking/tracking-snowplow.js');
const TrackingEvents = require('tracking/tracking-events.js');
const SharedDataService = require('data/shared-data-service.js');
const CurrentUser = require('user/current-user-service.js');
const SentryService = require('exceptions/sentry-service.js');
const QueryParameters = require('helpers/query-parameters.js');

/**
 *  Manage tracking events within `Homepage` project
 */
const Tracking = (function(root, doc, undefined) {

    'use strict';

    /*
     * Send an event to all tracking provider
     * @params {String} - eventName
     * @params {Object} - data
     */
    const sendEvent = (eventName, data) => {
        GTM.sendEvent(eventName, data);
        Optimizely.sendEvent(eventName, data);
        Snowplow.sendEvent(eventName, data);
    };

    /**
     * Extends the data parameters for all the events
     * with common data that must be passed for all events.
     * @param  {Object} data - data event extension
     * @return {Object}
     */
    const extendWithCommonData = (data) => {
        const params = Utils.deepClone(data);
        return Object.assign(params, QueryParameters.getInstitutionParameters());
    };

    /**
     * Every time we fire an event, we try to authenticate
     * the user in order to add additional infos on the event.
     * Those infos are added inside the identifyUser() method.
     */
    const send = (eventName, data = {}) => {
        const trackingName = TrackingEvents[eventName];
        data = extendWithCommonData(data);
        CurrentUser.get().then(identifyUser).finally(sendEvent.bind(null, trackingName, data)).done();
    };

    /*
     * When user is recognised, we add extra data to trackers.
     * We add a logic to avoid multiple authentications
     * based on the current user id. In some cases this ID can change
     * and a new user needs to be identified. (e.g.: registration)
     */
    const identifyUser = (user) => {

        if (currentUserID === user.uid) {
            return false;
        }

        // Add Sentry user context
        SentryService.identifyUser(user);

        // Add extra GTM user infos
        GTM.identifyUser(user);

        // Send current user info to Optimizely
        Optimizely.identifyUser(user);

        // Send user info to Snowplow
        Snowplow.identifyUser(user);

        // Store userID to avoid multiple authentications
        currentUserID = user.uid;

    };

    const init = () => {

        /**
         * Everytime the app load, we store a
         * marketing data object in the session storage.
         */
        SharedDataService.storeMarketingData();

        // Load GTM
        GTM.load({
            logs: false
        });

        Optimizely.load({
            logs: false
        });

        Snowplow.load({
            logs: false
        });

    };

    /**
     * Private consts
     */
    const filename = 'tracking-controller.js';
    let currentUserID = null;

    init();

    return {
        send: send
    };

})(window, document);

module.exports = Tracking;
